'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _vuex = require('vuex');

var _vuex2 = _interopRequireDefault(_vuex);

var _getters = require('./getters');

var getters = _interopRequireWildcard(_getters);

var _mutations = require('./mutations');

var _mutations2 = _interopRequireDefault(_mutations);

var _actions = require('./actions');

var actions = _interopRequireWildcard(_actions);

var _state = require('./state');

var _state2 = _interopRequireDefault(_state);

var _message = require('./message');

var _message2 = _interopRequireDefault(_message);

var _logger = require('vuex/dist/logger');

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var debug = process.env.NODE_ENV !== 'production';
//开发环境日志输出

_vue2.default.use(_vuex2.default);
var vuexInstance = new _vuex2.default.Store({
  getters: getters,
  state: _state2.default,
  mutations: _mutations2.default,
  strict: debug,
  actions: actions,
  plugins: debug ? [(0, _logger2.default)()] : [],
  modules: {
    message: _message2.default
  }
});
exports.default = vuexInstance;